import type Store from '@ember-data/store'
import Route from '@ember/routing/route'
import { service } from '@ember/service'
import { all } from 'rsvp'
import type SessionService from 'teacher-ui-client/services/session'
import type SubscriptionUtilisationService from 'teacher-ui-client/services/subscription-utilisation'
import type Controller from '@ember/controller'
import type Transition from '@ember/routing/transition'
import type Student from 'teacher-ui-client/models/student'
import type SchoolClass from 'teacher-ui-client/models/school-class'

export default class ManageStudentsRoute extends Route {
  @service subscriptionUtilisation!: SubscriptionUtilisationService

  @service session!: SessionService

  @service store!: Store

  queryParams = {
    sortCol: {
      replace: true,
    },
    sortDir: {
      replace: true,
    },
    sortCompare: {
      replace: true,
    },
    currentPage: {
      replace: true,
    },
    textFilter: {
      replace: true,
    },
    selectedIds: {
      replace: true,
    },
    recordsPerPage: {
      replace: true,
    },
  }

  buildRouteInfoMetadata() {
    return {
      rolloverLock: {
        subco: {
          lockOtherSubscriptionType: true,
        },
        teacher: {
          lockCurrentSubscriptionType: true,
          lockOtherSubscriptionType: true,
        },
      },
    }
  }

  async model() {
    const allStudentsPromise = this.store.query<Student>('student', {
      // @ts-expect-error - include types not correct
      include: 'school-classes',
    })
    const allSchoolClassesPromise = this.store.query<SchoolClass>('school-class', {
      // @ts-expect-error - include types not correct
      include: 'teachers',
    })

    const [allStudents, allSchoolClasses] = await all([
      allStudentsPromise,
      allSchoolClassesPromise,
      this.subscriptionUtilisation.fetchAll(),
    ])

    return {
      allStudents,
      allSchoolClasses,
      currentTeacher: this.session.currentTeacher,
      currentSchool: this.session.currentSchool,
    }
  }

  setupController(
    controller: Controller & { resetGroupFilterOption: () => unknown },
    model: unknown,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition)
    // Reset the teacher/school-class group filter. Avoids the issue of a reading class being selected, then the teacher
    // navigates to maths side for the same page and the reading class is still the selected option.
    controller.resetGroupFilterOption()
  }
}
